import { NavLink, useLocation } from 'react-router-dom'
import { Home, Users, FileText, Database } from 'lucide-react'
import { cn } from '@/utils/cn'

const navigation = [
  { name: 'Dashboard', href: '/dashboard', icon: Home },
  { name: 'Clients', href: '/clients', icon: Users },
  { name: 'Programs', href: '/programs', icon: FileText },
  { name: 'Library', href: '/library', icon: Database },
]

export function MobileBottomNav() {
  const location = useLocation()

  return (
    <div className="mobile-bottom-nav">
      <nav className="flex items-center justify-around h-16 px-2">
        {navigation.map((item) => {
          const Icon = item.icon
          const isActive = location.pathname === item.href || 
                         (item.href !== '/dashboard' && location.pathname.startsWith(item.href))
          
          return (
            <NavLink
              key={item.name}
              to={item.href}
              className={cn(
                'flex flex-col items-center justify-center space-y-1 px-2 py-1 rounded-lg transition-colors touch-target',
                isActive
                  ? 'text-primary-600'
                  : 'text-gray-500 hover:text-gray-700'
              )}
            >
              <Icon className="w-5 h-5" />
              <span className="text-xs font-medium">{item.name}</span>
            </NavLink>
          )
        })}
      </nav>
    </div>
  )
}